module.exports = __webpack_public_path__ + "static/media/speaker5.cd1ff413.png";